import { GetOrdersPaginatedQuery, OrderState } from 'data/__generated__';

export type OrderRow = GetOrdersPaginatedQuery['ordersFilter']['orders'][number];

export const ORDER_COLUMN_LABELS = {
    archived: 'Archivées',
    created: 'Créées',
    validated: 'Validées',
    readyRecurring: 'Prêtes récurrentes',
    readyPunctual: 'Prêtes ponctuelles',
    onboarding: 'Première commande',
    pausedToReactivate: 'En pause à reactiver',
    paused: 'En pause',
    draftNProspects: 'Prospect',
    inProgress: 'En cours',
};

export type OrderBucketKey = keyof typeof ORDER_COLUMN_LABELS;

/** L'ordre des colonnes du kanban, inchangé. */
export const ORDER_BUCKET_ORDER: OrderBucketKey[] = [
    'readyRecurring',
    'readyPunctual',
    'validated',
    'onboarding',
    'inProgress',
    'pausedToReactivate',
    'created',
    'paused',
    'draftNProspects',
    'archived',
];

/**
 * Les colonnes du kanban ne sont PAS les états d'une commande : ce sont des regroupements métier qui
 * croisent l'état avec `isPunctual`, `first_order` et la date de retour d'une pause. D'où ce classement
 * explicite, extrait de la page pour que la vue kanban n'ait plus qu'à le consommer.
 */
export function groupOrdersIntoBuckets(orders: OrderRow[]): Record<OrderBucketKey, OrderRow[]> {
    const todayNumeric = new Date().setHours(0, 0, 0, 0);

    const buckets: Record<OrderBucketKey, OrderRow[]> = {
        archived: [],
        readyRecurring: [],
        readyPunctual: [],
        validated: [],
        onboarding: [],
        pausedToReactivate: [],
        paused: [],
        draftNProspects: [],
        inProgress: [],
        created: [],
    };

    orders.forEach((order) => {
        if (order.state === OrderState.Archived) {
            buckets.archived.push(order);
            return;
        }
        if (order.state === OrderState.Ready) {
            (order.isPunctual ? buckets.readyPunctual : buckets.readyRecurring).push(order);
            return;
        }
        if (order.state === OrderState.Validated) {
            (order.first_order ? buckets.onboarding : buckets.validated).push(order);
            return;
        }
        if (order.state === OrderState.Paused) {
            const returnDate = order.pausedInfo?.returnDate;
            (returnDate && returnDate <= todayNumeric ? buckets.pausedToReactivate : buckets.paused).push(order);
            return;
        }
        if ([OrderState.Created, OrderState.InProgress].includes(order.state)) {
            if (order.isPunctual || order.first_order) {
                buckets.draftNProspects.push(order);
            } else if (order.state === OrderState.InProgress) {
                buckets.inProgress.push(order);
            } else {
                buckets.created.push(order);
            }
        }
    });

    return buckets;
}
